import { render, staticRenderFns } from "./DetailedCalendar.vue?vue&type=template&id=48f6ae7b&"
import script from "./DetailedCalendar.vue?vue&type=script&lang=ts&"
export * from "./DetailedCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./DetailedCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCalendar } from 'vuetify/lib/components/VCalendar';
installComponents(component, {VCalendar})
